import { ChangeEvent, FC, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { useSimulationBank } from '../../../../../providers/SimulationBank/SimulationBankProvider';

// Campo "Agente de Digitação", exibido no espelho (StepConfirmacao) quando o parceiro
// logado não é comissionado — mesma UX do filtro "por código" do histórico de conversa
// (SidebarChatsListFilter/InputSearchPartner): digita o código e o nome do parceiro é
// resolvido automaticamente. Diferente daquele componente, aqui a consulta é feita contra
// simulation/digitations/partner-commission (via validateTypingAgentCode no provider), que
// já devolve um único parceiro — sem necessidade de um select para desambiguar resultados.
const TypingAgentField: FC = () => {
    const { typingAgent, isCheckingTypingAgent, typingAgentError, validateTypingAgentCode, clearTypingAgent } = useSimulationBank();
    const [code, setCode] = useState('');

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value);
        if (typingAgent || typingAgentError) clearTypingAgent();
    };

    const handleBlur = () => {
        const trimmed = code.trim().toUpperCase();
        if (!trimmed) return;
        validateTypingAgentCode(trimmed);
    };

    return (
        <div className="fgroup typing-agent-field">
            <label>Código do agente de digitação <span className="req">*</span></label>
            <div className="typing-agent-field__row">
                <input
                    type="text"
                    placeholder="Ex.: SP17-6067"
                    value={code}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={typingAgentError ? 'invalid' : ''}
                />
                <div className="typing-agent-field__result">
                    {isCheckingTypingAgent ? (
                        <FontAwesomeIcon icon={faSpinner} spin />
                    ) : typingAgent ? (
                        <span className="typing-agent-field__name">
                            <FontAwesomeIcon icon={faCircleCheck} />
                            {typingAgent.nome}
                        </span>
                    ) : (
                        <span className="typing-agent-field__placeholder">Nome do parceiro</span>
                    )}
                </div>
            </div>
            {typingAgentError && <p className="error">{typingAgentError}</p>}
        </div>
    );
};

export default TypingAgentField;
